export function selectBookType(ctx, payload) {
    ctx.dispatch('CLEAR_DESIGNS', payload.data);
    ctx.dispatch('SELECT_BOOK_TYPE', payload);
}
